export default __webpack_public_path__ + "static/media/doctor-4.b18e5702.jpg";